import React from 'react';
import { useEffect, useState } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Logs from '../../../src/components/Logs/Logs.js';
import Alerts from '../../components/Alerts/Alerts';
import Dashboard from '../../components/Dashboard/Dashboard.js';
import Projectdetails from '../../components/Insidedetails/Projectdetails';
import ServiceList from '../../components/ServiceList/ServiceList.js';
import { useParams } from 'react-router-dom';
import Hamburger from '../../components/HamburgerMenu/HamburgerMenu.js';
import { onUpdateProject } from '../../store/app/actions.js';
import { fetchProjectDetails } from '../../store/app/apis';
import { connect } from 'react-redux';
import CircularProgress from '@mui/material/CircularProgress';
export function ProjectDetails({ sprogress, onUpdateProject, projectList, fetchProjectDetails }) {
  const params = useParams();
  const [value, setValue] = React.useState(0);
  const handleTabs = (event, val) => {
    setValue(val);
  };
  const [state, setState] = useState({
    title: '',
    hookid: '',
    dashboard: '',
    baseurl: '',
  });
  useEffect(() => {
    if (!params.id) return;
    if (projectList?.length !== 0) setState(projectList?.find((project) => project.id === params.id));
    else {
      fetchProjectDetails(params.id).then((res) => {
        setState(res);
      });
    }
  }, [params.id]);
  useEffect(() => {
    onUpdateProject(params.id);
  }, [sprogress]);
  const tabStyle = {
    minWidth: 0,
    padding: 0,
    '&.Mui-selected': { color: 'red' },
  };
  useEffect(() => {
    return () => {
      onUpdateProject('');
    };
  }, []);
  const styles = {
    '& .Mui-selected': {
      backgroundColor: 'transparent',
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    '& .MuiTab-root': {
      backgroundColor: 'transparent',
      boxShadow: 'none',
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    '& .MuiTabs-root': {
      paddingLeft: '15px',
    },
  };

  return (
    <div className="totals">
      {!sprogress && <CircularProgress sx={{ position: 'absolute', top: '50%', left: '50%' }} />}
      {sprogress && (
        <div>
          <h1>Project Monitor</h1>
          <Hamburger></Hamburger>
          <div className="tabs">
            <Tabs
              sx={styles}
              value={value}
              onChange={handleTabs}
              // TabIndicatorProps={{
              //   style: {
              // backgroundColor: 'red'
              //   }
              // }}
              // sx={{ '.MuiTabs-flexContainer': { gap: '30px' }, marginLeft: '40px' }}
            >
              <Tab
                label="Services"
                // sx={tabStyle}
              />
              <Tab
                label="Details"
                // sx={tabStyle}
              />
              <Tab
                label="Logs"
                // sx={tabStyle}
              />
              <Tab
                label="Alerts"
                // sx={tabStyle}
              />
              {state?.dashboard === 'DAM' && (
                <Tab
                  label={[state?.dashboard]}
                  // sx={tabStyle}
                />
              )}
            </Tabs>
          </div>
          {value === 0 && <ServiceList projects={[params.id]} />}
          {value === 1 && <Projectdetails />}
          {value === 2 && <Logs logtype={'project'} />}
          {value === 3 && <Alerts logtype={'project'} />}
          {value === 4 && state?.dashboard === 'DAM' && <Dashboard baseurl={state?.baseurl} />}
        </div>
      )}
    </div>
  );
}
const mapStateToProps = (state) => {
  return {
    sprogress: state.app.sprogress,
    projectList: state.app.projectList,
  };
};
const mapDispatchToProps = {
  onUpdateProject,
  fetchProjectDetails,
};
export default connect(mapStateToProps, mapDispatchToProps)(ProjectDetails);
